// removed by extract-text-webpack-plugin
module.exports = {"electro":"_2j0k47990k6a80Mpf09uHQ","hovered":"_1QT1pwfGn1FI8uYCUi3BVV","caption":"_3l764WGDYQ8-4d2oVaTuTU","tg":"_3ZDHAO1qQaR0wmoe4Cn08f","value":"ZifULvpFKwTzF3xf2OKJ9","disabled":"_3wM3P7f1CxggK8UsDxB3f0"};


//////////////////
// WEBPACK FOOTER
// ./src/components/entries/Electrotable/style.css
// module id = 284
// module chunks = 0